import { Info } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import React from 'react';

import { CustomTooltipProps } from './CustomTooltip.types';


const CustomTooltip = ({ icon, text, placement = 'top' }: CustomTooltipProps) => {
  return (
    <Tooltip
      title={text}
      arrow
      placement={placement}
      slotProps={{
        popper: {
          sx: { zIndex: 3000 }, // Ensure tooltip appears above other elements (under 3000 was not enough for some modals)
        },
      }}
    >
      <Box
        component='span'
        sx={{
          display: 'inline-flex',
          cursor: 'help',
        }}
      >
        {icon || <Info sx={{ fontSize: '1rem', mb: '5px' }} />}
      </Box>
    </Tooltip>
  );
};

export default CustomTooltip;
